export default __webpack_public_path__ + "static/media/ico-galeria.36081644.svg";